import dayjs from "dayjs";

import "dayjs/locale/es";

/**
 * Fechas del documento, siempre en español.
 *
 * El idioma se pide en CADA llamada en vez de fiarse de `dayjs.locale("es")`
 * global. Ese global lo pone el punto de entrada, y un modulo que se renderice
 * sin pasar por el -- una prueba, un render de servidor, un script -- saca las
 * fechas en ingles sin avisar. Aqui no puede pasar: el locale viaja con la
 * funcion que lo necesita.
 */
export const mesAnio = (fecha: string | null): string =>
  fecha ? dayjs(`${fecha}-01`).locale("es").format("MMM YYYY") : "";
